import { useState } from "react";
import { toast } from "sonner";
import { X, KeyRound } from "lucide-react";
import api, { formatApiErrorDetail } from "../api";
import { PasswordInput, PasswordStrength } from "./PasswordInput";

export const ChangePasswordModal = ({ onClose, forced = false, onChanged }) => {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) { setError("Les deux nouveaux mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: pw });
      toast.success("Mot de passe changé !");
      if (onChanged) onChanged();
      if (onClose) onClose();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" data-testid="change-password-modal">
      <div className="w-full max-w-sm bg-[#14141A] border border-[#2E2E3A] p-5">
        <div className="flex items-center justify-between mb-2">
          <p className="font-display text-2xl text-white flex items-center gap-2">
            <KeyRound size={20} className="text-[#FF3B30]" /> MOT DE PASSE
          </p>
          {!forced && (
            <button data-testid="change-password-close-button" onClick={onClose} className="text-[#B0B0B4] hover:text-white p-1">
              <X size={18} />
            </button>
          )}
        </div>
        {forced && (
          <p data-testid="forced-change-notice" className="text-amber-400 text-xs mb-3">
            Ton mot de passe a été réinitialisé par l'admin. Choisis-en un nouveau pour continuer.
          </p>
        )}
        <form onSubmit={submit} className="space-y-3">
          <PasswordInput testId="current-password-input" placeholder={forced ? "Mot de passe temporaire" : "Mot de passe actuel"}
            value={current} onChange={(e) => setCurrent(e.target.value)} />
          <PasswordInput testId="new-password-input" placeholder="Nouveau mot de passe (8 car. min)"
            value={pw} onChange={(e) => setPw(e.target.value)} />
          <PasswordStrength password={pw} />
          <PasswordInput testId="new-password-confirm-input" placeholder="Confirme le nouveau mot de passe"
            value={pw2} onChange={(e) => setPw2(e.target.value)} />
          {error && <p data-testid="change-password-error" className="text-[#FF3B30] text-sm">{error}</p>}
          <button data-testid="change-password-submit-button" disabled={loading}
            className="w-full h-11 bg-[#FF3B30] text-white font-display text-xl tracking-wide hover:bg-[#e0322a] transition-colors disabled:opacity-50">
            {loading ? "..." : "CHANGER"}
          </button>
        </form>
      </div>
    </div>
  );
};
